<template>
  <div class="reports__panel--print">
    <button class="button is-primary" @click="$emit('submit')">
      {{ text }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'reports-panel-print',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: 'Print'
    }
  }
}
</script>

<style lang="scss">
.reports__panel--print {
  display: flex;
  align-items: flex-end;
  padding-bottom: 4px;

  button {
    height: 28px !important;
  }
}
</style>